import { all, call, put, takeLatest, select } from "redux-saga/effects";

import Schemas from "../models";
import actions from "../../constants/actions";
import { GET, POST, DELETE } from "../../utils/api";
import { getLocale } from "../selectors/app";

export function* getSpaces({ payload }) {
    const locale = yield select(getLocale);

    try {
        let response = yield call(GET, {
            url: "api/spaces/",
            schema: Schemas.SPACE_ARRAY,
            locale,
        });

        yield put({
            type: actions.SPACES.LOAD_LIST_SUCCESS,
            payload: response,
        });
    } catch (error) {
        yield put({ type: actions.SPACES.LOAD_LIST_FAIL, payload: error });
    }
}

export function* getSpace({ payload }) {
    const locale = yield select(getLocale);

    try {
        let response = yield call(GET, {
            url: "api/spaces/" + payload.slug,
            schema: Schemas.SPACE,
            locale,
        });

        yield put({
            type: actions.SPACES.LOAD_SUCCESS,
            payload: response,
        });
    } catch (error) {
        yield put({ type: actions.SPACES.LOAD_FAIL, payload: error });
    }
}

export function* getSlotsAvailable({ payload }) {
    const locale = yield select(getLocale);

    try {
        let response = yield call(GET, {
            url:
                "api/spaces/slots/" +
                payload.id +
                "/" +
                payload.begin +
                "/" +
                payload.end,
            locale,
        });

        yield put({
            type: actions.SPACES.LOAD_SLOTS_AVAILABLE_SUCCESS,
            payload: response,
        });
    } catch (error) {
        yield put({
            type: actions.SPACES.LOAD_SLOTS_AVAILABLE_FAIL,
            payload: error,
        });
    }
}

export default function* Spaces() {
    yield all([
        yield takeLatest(actions.SPACES.LOAD_LIST, getSpaces),
        yield takeLatest(actions.SPACES.LOAD, getSpace),
        yield takeLatest(
            actions.SPACES.LOAD_SLOTS_AVAILABLE,
            getSlotsAvailable
        ),
    ]);
}
